import { Platform, CommonRuntime } from "utils/runtime";
import { middleEast } from "./currency";

export const formatPriceWithPoint = function (price: number | string, bit = 2) {
	if (typeof price === "string") {
		price = parseFloat(price);
	}
	const base = Math.pow(10, bit);

	return (Math.round(price * base) / base).toFixed(bit);
};

export const stringToPrice = function (priceString: string) {
	// eslint-disable-next-line no-useless-escape
	return parseFloat(priceString.replace(/[^\.\d]/g, ""));
};

export function transferMixUnitPrice(integerPrice: number) {
	const price = integerPrice / 100;
	return Number(price.toFixed(2));
}

export const transformProductPrice = (
	price: string,
	runtime: CommonRuntime,
	isOrigin: boolean = false,
) => {
	const { currency } = runtime;
	const nextPrice = transformPriceByCurrency(currency, price);
	const priceGraph = handlePriceWithCondition({ price: nextPrice, runtime, isOrigin });
	if (priceGraph) {
		return priceGraph;
	}
	if (runtime.platform === Platform.WEB) {
		return `${currency} ${runtime.priceGraph}${nextPrice}`;
	}
	return `${runtime.priceGraph}${nextPrice}`;
};
/** 下划线价格单位 */
const PriceUnderlinkSymbol = {
	MXN: "$",
	CHF: "₣",
};

export interface TransformProductPriceParam {
	price: string;
	runtime: CommonRuntime;
	isOrigin?: boolean;
}
/**
 * 平台(pc or m)公用的F
 * @returns string
 */
function handlePriceWithCondition({
	runtime,
	price,
	isOrigin,
}: Partial<TransformProductPriceParam>) {
	const { currency, priceGraph: priceSymbol } = runtime;

	if (middleEast.includes(currency)) {
		return `${currency} ${price}`;
	} else if (["MXN", "CHF"].includes(currency)) {
		const symbol = isOrigin ? PriceUnderlinkSymbol[currency.toLocaleUpperCase()] : priceSymbol;
		return `${symbol}${price}`;
	} else if(["KZT"].includes(currency)) {
		return `${currency} ${priceSymbol}${price}`;
	} else if (["JOD", "CAD", "RON", "BGN", "HUF", "TRY"].includes(currency)) {
		return `${isOrigin ? "" : currency} ${priceSymbol}${price}`;
	}
	return "";
}

function transformPriceByCurrency(currency: string, price: string) {
	if (["BRL"].includes(currency)) {
		return price.replace(".", ",");
	}
	return price;
}
